import styled from 'styled-components';

const SortBySelected = styled.span`
  margin-top: 2px;
  font-weight: bolder;
  font-style: normal;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export default SortBySelected;
